import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SpinnerService } from '@services/generic/spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinner: SpinnerService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Escuchamos si existe un queryParams que indique no mostrar spinner
    const showSpinner = req.params.get('spinner');
    if (showSpinner && showSpinner === 'false') { return next.handle(req) }

    this.spinner.setLoading(true, req.url);

    return next.handle(req)
      .pipe(
        map((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse || evt instanceof HttpErrorResponse)
            this.spinner.setLoading(false, req.url);
          return evt;
        }),
        catchError((err) => {
          this.spinner.setLoading(false, req.url);
          return throwError(err);
        }),
      )

  }
}
